// the applied component should be button for this moment
$(document).on('turbolinks:load', function () {
  var overlayOnSubmitButtonComponent = $('*[data-overlay-on-submit="true"]');
  if (overlayOnSubmitButtonComponent.length) {
    overlayOnSubmitButtonComponent.on("click", function(){
      $('#overlay-on-submit-layer-js').removeClass("d-none");
    });
  }
});